<template>
    <div class="header-container">
        <h1 class="logo-box" v-if="store.getters.userInfo.school_name != '源控'">
            <i class="iconfont icon-logo" />
            <img src="@/assets/images/logo.png" alt="" class="system-name" />
        </h1>
        <el-menu
            class="header-menu"
            mode="horizontal"
            :default-active="activeIndex"
            background-color="transparent"
            :ellipsis="false"
            @select="handleSelect"
        >
            <el-menu-item v-for="item in moduleList" :index="item.id" :key="item.id">{{ item.name }}</el-menu-item>
        </el-menu>
        <el-button-group class="user-info">
            <el-tooltip effect="dark" content="个人信息" placement="bottom">
                <el-button type="primary" :icon="User" round @click="router.push('/index')">
                    {{ store.getters.userInfo.username }}
                </el-button>
            </el-tooltip>
            <el-button type="primary" round @click="logout">退出</el-button>
        </el-button-group>
    </div>
</template>
<script setup>
import { onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { getModuleOptionLists } from '@/api/module'
import { User } from '@element-plus/icons'

const props = defineProps({
    showMenu: {
        type: Boolean,
        default: true
    }
})

const store = useStore()
const logout = () => {
    store.dispatch('user/logout')
    store.dispatch('permission/saveSubsystem', store.getters.userInfo.is_system_admin ? 'base' : 'heating')
}
let activeIndex = store.getters.userInfo.is_system_admin ? 'base' : 'heating'
const allMenus = store.getters.userInfo && store.getters.userInfo.auths && store.getters.userInfo.auths.menus

const handleSelect = async (index) => {
    store.dispatch('permission/saveSubsystem', index)
    if (allMenus) {
        store.dispatch('permission/saveMenu', allMenus[index] || [])
        const menuList = allMenus[index]
        const firstLeafNode = getFirstLeafNode(menuList)
        const query = firstLeafNode.query ? JSON.parse(firstLeafNode.query.slice(1, -1)) : ''

        router.push({
            path: getFullPath(menuList, ''),
            query
        })
    }
}
const getFirstLeafNode = (nodes) => {
    for (const node of nodes) {
        if (!node.children || !node.children.length) {
            return node
        } else {
            const result = getFirstLeafNode(node.children)
            if (result) return result
        }
    }
    return null
}
const getFullPath = (nodes, paths) => {
    let full_path = paths
    for (const node of nodes) {
        if (node.path && node.path !== '/') {
            if (node.path.substring(0, 1) === '/') {
                full_path += node.path
            } else {
                full_path += '/' + node.path
            }
        }
        if (!node.children || !node.children.length) {
            return full_path
        } else {
            const result = getFullPath(node.children, full_path)
            if (result) return result
        }
    }
    return null
}
const moduleList = ref([])
const getModuleOptionListsFun = async () => {
    const data = await getModuleOptionLists()
    moduleList.value = data.filter((ele) => Object.keys(allMenus).includes(ele.id)).filter((ele) => ele.visible)
}

onMounted(() => {
    getModuleOptionListsFun()
})

const work = ref(store.getters.userInfo.is_system_admin ? 'base' : 'heating')

watch(
    router.currentRoute,
    () => {
        work.value = localStorage.getItem('subsystem')
        activeIndex = localStorage.getItem('subsystem')
    },
    { immediate: true, deep: true }
)
</script>
<style scoped lang="scss">
.header-container {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-box {
        width: 230px;
        display: flex;
        align-items: center;

        .icon-logo {
            font-size: 38px;
            color: var(--theme-color);
        }
        .system-name {
            width: 150px;
        }
    }

    .header-menu {
        flex: 1;
        border: none !important;
        margin-right: 100px;
    }

    .user-info {
        display: flex;
        align-items: center;
        line-height: 1.5;

        .username {
            margin-right: 15px;
        }

        .logout {
            font-size: 14px;
            color: #606266;
            cursor: pointer;
        }
    }
}
</style>
<style lang="scss">
.header-menu.el-menu--horizontal {
    border-bottom: none;
    .el-menu-item:not(.is-disabled):focus,
    .el-menu-item:not(.is-disabled):hover {
        background-color: var(--el-color-primary-light-7);
    }
}

.header-menu.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;

    &::after {
        content: '';
        width: 10px;
        height: 3px;
        background-color: var(--el-color-primary);
        position: absolute;
        top: 74%;
    }
}
</style>
